import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const FieldDatePicker = ({
  name,
  label,
  placeholder,
  options,
  value,
  onChange,
  style,
  disabled,
}) => {
  return (
    <Flatpickr
      value={value ? new Date(value) : null}
      options={{ dateFormat: "d-m-Y", ...options }}
      onChange={(selectedDates) => {
        const date = selectedDates[0];
        if (date) {
          const formattedDate = `${date.getFullYear()}-${String(
            date.getMonth() + 1
          ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
          onChange(formattedDate);
        }
      }}
      placeholder={placeholder || "Select Date"}
      className="flatpickr-input form-control commonInput"
      style={style}
      disabled={disabled}
    />
  );
};

export default FieldDatePicker;
